/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



//Disabout click
const noClickElements = document.querySelectorAll('.cursor-text');
const onClickHandler = (ev) => {
  ev.preventDefault(); ev.stopPropagation(); return false;
};
noClickElements.forEach(noClickElement => noClickElement.addEventListener('click', onClickHandler));

let textarea = document.querySelector('.gift_note_textarea');
let textareaCopy = document.querySelector('.gift-note-copy');
let current = document.querySelector('.gift_note_textarea_currentt');

if(textarea && textareaCopy && current) {
  textarea.addEventListener('keyup', function () {
    const characterCount = this.value.length;
    const max = textarea.getAttribute('maxlength');
    let remaning = max - characterCount;
    textareaCopy.value = textarea.value;
    current.textContent = remaning + " Characters Remaining";
  });
}

document.addEventListener('cart:rerendered', function(event) {
  textarea = document.querySelector('.gift_note_textarea');
  textareaCopy = document.querySelector('.gift-note-copy');
  current = document.querySelector('.gift_note_textarea_currentt');
  
  if(textarea && textareaCopy && current) {
    textarea.addEventListener('keyup', function () {
      const characterCount = this.value.length;
      const max = textarea.getAttribute('maxlength');
      let remaning = max - characterCount;
      textareaCopy.value = textarea.value;
      current.textContent = remaning + " Characters Remaining";
    });
  }
});

document.addEventListener('theme:collection:end', function (event) {
  
});